import gsap from 'gsap';
import { disablePageScroll, enablePageScroll } from "scroll-lock";
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, EffectCube } from 'swiper/modules';
import loadImages from '../../app';

function sliderStories() {
  const sliders = {};
  const timers = {};
  let groupSlider;

  const groupSliderWrapper = $('.swiper-group-stories');
  const close = $('.popup-stories__bg, .popup-stories__close, .popup-stories__button');
  const bg = $('.popup-stories__bg');
  const buttons = $('.popup-trigger');

  let reachEndTimer;

  const createSwiper = (popupId) => {
    const container = document.querySelector(`
      .popup-stories[data-popup-id="${popupId}"] .swiper-stories`
    );
    
    if (container && !sliders[popupId]) {
      try {
        sliders[popupId] = new Swiper(container, {
          modules: [Pagination, Navigation, Autoplay],
          spaceBetween: 20,
          grabCursor: true,
          pagination: {
            clickable: true,
            el: `.popup-stories[data-popup-id="${popupId}"] .swiper-pagination`,
          },
          autoplay: {
            enabled: false, // Изначально autoplay отключен
            delay: 15000, // Задержка в 15 секунд
            disableOnInteraction: false,
            stopOnLastSlide: true
          },
          navigation: {
            prevEl: `.popup-stories[data-popup-id="${popupId}"] .swiper-button-prev`,
            nextEl: `.popup-stories[data-popup-id="${popupId}"] .swiper-button-next`,
          },
          watchSlidesProgress: true,
          on: {
            init() {
              loadImages();
            },
            reachEnd() {
              const container = document.querySelector(
                `.popup-stories[data-popup-id="${popupId}"] .swiper-stories`
              );
          
              if (container) {
                const slidesCount = container.querySelectorAll('.swiper-slide').length;
          
                // Если это последний слайд и только один слайд
                if (slidesCount === 1 && groupSlider.activeIndex + 1 === groupSlider.slides.length) {
                  reachEndTimer = setTimeout(() => {
                    closePopup(popupId);
                  }, sliders[popupId]?.params.autoplay.delay || 15000); // Используем delay autoplay или 15 секунд по умолчанию
                } else if (slidesCount > 1) {
                  reachEndTimer = setTimeout(() => {
                    groupSlider.slideNext();
          
                    // Отмечаем триггер как просмотренный
                    const trigger = buttons.filter(`[data-popup-button-id="${popupId}"]`);
                    if (trigger.length) {
                      trigger.parent().addClass('seen');
          
                      // Сохраняем состояние в localStorage
                      const seenStories = JSON.parse(localStorage.getItem('seenStories')) || [];
                      if (!seenStories.includes(popupId)) {
                        seenStories.push(popupId);
                        localStorage.setItem('seenStories', JSON.stringify(seenStories));
                      }
                    }
                  }, sliders[popupId]?.params.autoplay.delay);
                }
              }
            },
            autoplayTimeLeft(timeLeft) {
              if (timeLeft.autoplay.timeLeft == 0 || timeLeft.autoplay.timeLeft < 0) {
                groupSlider.slideNext();
                const trigger = buttons.filter(`[data-popup-button-id="${popupId}"]`);
                if (trigger.length) {
                  trigger.parent().addClass('seen');
                  
                  // Сохраняем состояние в localStorage
                  const seenStories = JSON.parse(localStorage.getItem('seenStories')) || [];
                  if (!seenStories.includes(popupId)) {
                    seenStories.push(popupId);
                    localStorage.setItem('seenStories', JSON.stringify(seenStories));
                  }
                }
              }
            },
            slideChange() {

              const swiper = sliders[popupId];

              // Очищаем предыдущий таймер при переключении слайда
              if (timers[popupId]) {
                clearTimeout(timers[popupId]);
                timers[popupId] = null;
                clearTimeout(reachEndTimer);
              }

              // Если активный слайд последний, устанавливаем новый таймер
              if (swiper && swiper.isEnd) {
                setupTimeout(popupId);
              }
            }
          },
        });
      } catch (error) {
        console.error(`Ошибка при инициализации Swiper для popupId ${popupId}:`, error);
      }
    }
  };

  const setupTimeout = (popupId) => {
    const autoplayDelay = sliders[popupId]?.params.autoplay.delay;
    const countSliders = $('.popup-stories').length;

    if (timers[popupId]) {
      clearTimeout(timers[popupId]);
    }

    timers[popupId] = setTimeout(() => {
      const swiper = sliders[popupId];
      if (swiper && swiper.isEnd) {
        if (groupSlider.activeIndex + 1 == countSliders) {
          closePopup(popupId);
        }
      }
    }, autoplayDelay);
  };

  const enableAutoplay = (popupId) => {
    if (sliders[popupId]) {
      try {
        sliders[popupId].params.autoplay.enabled = true;
        sliders[popupId].autoplay.start();
      } catch (error) {
        console.error(`Ошибка при активации autoplay для popupId ${popupId}:`, error);
      }
    }
  };

  const disableAutoplay = (popupId) => {
    if (sliders[popupId]) {
      try {
        sliders[popupId].autoplay.stop();
        sliders[popupId].params.autoplay.enabled = false;
      } catch (error) {
        console.error(`Ошибка при остановке autoplay для popupId ${popupId}:`, error);
      }
    }
  };

  const destroySwiper = (popupId) => {
    if (sliders[popupId]) {
      try {
        sliders[popupId].destroy(true, true);
        delete sliders[popupId];
      } catch (error) {
        console.error(`Ошибка при уничтожении Swiper для popupId ${popupId}:`, error);
      }
    }
  };

  const closePopup = (popupId) => {
    const close = $('.popup-stories__close');

    // Очищаем таймер при закрытии попапа
    if (timers[popupId]) {
      clearTimeout(timers[popupId]);
      timers[popupId] = null;
    }
  
    bg.removeClass('active');
    close.removeClass('active');
    groupSliderWrapper.removeClass('active');

    destroySwiper(popupId);
    disableAutoplay(popupId);
    enablePageScroll();
  };

  // Функция для восстановления состояния
  const restoreSeenStories = () => {
    const seenStories = JSON.parse(localStorage.getItem('seenStories')) || [];
    seenStories.forEach(popupId => {
      const trigger = $(`.course-hero__story.popup-trigger[data-popup-button-id="${popupId}"]`);
      if (trigger.length) {
        trigger.parent().addClass('seen');
      }
    });
  };
  
  // Восстанавливаем состояния при загрузке страницы
  $(document).ready(() => {
    restoreSeenStories();
  });

  groupSlider = new Swiper('.swiper-group-stories', {
    modules: [Pagination, EffectCube],
    spaceBetween: 20,
    allowTouchMove: true,
    effect: "cube",
    cubeEffect: {
      shadow: true,
      slideShadows: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
    breakpoints: {
      415: {
        allowTouchMove: false,
      }
    },
    on: {
      slideChange() {

        clearTimeout(reachEndTimer);
        const activeIndex = groupSlider.activeIndex;

        // Обрабатываем каждый внутренний слайдер
        $('.popup-stories').each(function (index, element) {
          const popupId = $(element).data('popup-id');
          
          if (index === activeIndex) {
            createSwiper(popupId);
            enableAutoplay(popupId);

            // Отмечаем триггер как просмотренный
            const trigger = buttons.filter(`[data-popup-button-id="${popupId}"]`);
            if (trigger.length) {
              trigger.parent().addClass('seen');

              // Сохраняем состояние
              const seenStories = JSON.parse(localStorage.getItem('seenStories')) || [];
              if (!seenStories.includes(popupId)) {
                seenStories.push(popupId);
                localStorage.setItem('seenStories', JSON.stringify(seenStories));
              }
            }
          } else {
            destroySwiper(popupId);
            disableAutoplay(popupId);
          }
        });
      },
    },
  });

  // Открытие попапа
  buttons.on('click', function () {
    const button = $(this);
    const popupId = button.data('popup-button-id');
    const swiperEl = $(`.popup-stories[data-popup-id="${popupId}"] .swiper`);
    const close = $('.popup-stories__close');
  
    // Прокрутка группового слайдера
    groupSlider.slideTo(popupId - 1, 0);
    bg.toggleClass('active');
    swiperEl.toggleClass('active');
    close.toggleClass('active');
    groupSliderWrapper.toggleClass('active');
  
    if (groupSliderWrapper.hasClass('active')) {
      destroySwiper(popupId);
      createSwiper(popupId);
      enableAutoplay(popupId);
      disablePageScroll();
      
      // Добавляем класс 'seen' и сохраняем в localStorage
      button.parent().addClass('seen');
      const seenStories = JSON.parse(localStorage.getItem('seenStories')) || [];
      if (!seenStories.includes(popupId)) {
        seenStories.push(popupId);
        localStorage.setItem('seenStories', JSON.stringify(seenStories));
      }
    } else {
      closePopup(popupId);
    }
  });
  
  // Закрытие попапа через фоновый клик
  close.on('click', function () {
    closePopup();
  });

  $('.popup-stories .swiper-button-next').on('click', function() {
    if ($(this).hasClass('swiper-button-disabled')) {
      clearTimeout(reachEndTimer);
      groupSlider.slideNext();
    }
  });

  $(document).on('click', '.swiper-button-next.swiper-button-lock.swiper-button-disabled', function() {
    closePopup();
  });

  $('.popup-stories .swiper-button-prev').on('click', function () {
    if ($(this).hasClass('swiper-button-disabled')) {
      clearTimeout(reachEndTimer);
      groupSlider.slidePrev();
  
      // Получаем текущий popupId из активного слайда groupSlider
      const activeIndex = groupSlider.activeIndex;
      const popupId = $('.popup-stories').eq(activeIndex).data('popup-id');
  
      if (popupId) {
        createSwiper(popupId);
        enableAutoplay(popupId);
  
        // Прокручиваем внутренний слайдер на последний слайд
        const swiperInstance = sliders[popupId];
        if (swiperInstance) {
          const lastSlideIndex = swiperInstance.slides.length - 1;
          swiperInstance.slideTo(lastSlideIndex, 0);
        }
      }
    }
  });

  // Обработчик свайпа вниз
  let startY; // Начальная позиция по оси Y

  $('.swiper-group-stories').on('touchstart', function (event) {
    if (event.touches && event.touches.length > 0) {
      startY = event.touches[0].clientY; // Сохраняем начальную позицию касания
    }
  });

  $('.swiper-group-stories').on('touchmove', function (event) {
    if (startY !== undefined && event.touches && event.touches.length > 0) {
      const currentY = event.touches[0].clientY; // Текущая позиция касания
      const deltaY = currentY - startY; // Разница между текущей и начальной позицией

      if (deltaY > 150) { // Если свайп вниз больше 150px
        const activeIndex = groupSlider.activeIndex;
        const popupId = $('.popup-stories').eq(activeIndex).data('popup-id');
        let closePopupTimer;
        if (popupId) {
          gsap.to($('.swiper-group-stories'), {y: '100%', duration: 0.5, onComplete: () => {
            closePopup(popupId); // Закрываем попап
            closePopupTimer = setTimeout(function() {
              gsap.to($('.swiper-group-stories'), {y: '0', duration: 0, onComplete: () => {
                clearTimeout(closePopupTimer);
              }});
            }, 300);
          }});
          
        }

        startY = undefined; // Сбрасываем начальную позицию, чтобы обработать только один свайп
      }
    }
  });

  $('.swiper-group-stories').on('touchend', function () {
    startY = undefined; // Сбрасываем начальную позицию после завершения свайпа
  });

  // Добавляем логику для управления автоплеем при удержании пальца
  $('.swiper-group-stories').on('touchstart mousedown pointerdown', function () {
    const activeIndex = groupSlider.activeIndex;
    const popupId = $('.popup-stories').eq(activeIndex).data('popup-id');
    $('.swiper-group-stories').addClass('paused');
    if (popupId && sliders[popupId]) {
      sliders[popupId].autoplay.pause(); // Остановка автоплея активного слайдера
    }
  });

  $(document).on('touchend mouseup pointerup', function () {
    const activeIndex = groupSlider.activeIndex;
    const popupId = $('.popup-stories').eq(activeIndex).data('popup-id');
    $('.swiper-group-stories').removeClass('paused');
    if (popupId && sliders[popupId]) {
      sliders[popupId].autoplay.resume(); // Возобновление автоплея активного слайдера
    }
  });

}
sliderStories();